"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __importDefault(require("angular"));
class MeetingroomsInviteDisplayer {
    constructor($rootScope, MeetingroomsInviteManager, toast, $translate) {
        this.$rootScope = $rootScope;
        this.MeetingroomsInviteManager = MeetingroomsInviteManager;
        this.toast = toast;
        this.$translate = $translate;
        this.isolatedScope = {
            ongoingInvitations: 0
        };
        this.restrict = 'E';
        this.templateUrl = 'assets/javascripts/xchelper/directives/meetingroomsInviteDisplayer.html';
    }
    link(scope) {
        this.isolatedScope = angular_1.default.extend(scope, this.isolatedScope);
        const onNewInvitationCount = (e, count) => {
            this.isolatedScope.ongoingInvitations = count;
            if (!this.$rootScope.$$phase)
                scope.$apply();
        };
        const onDisplayInvitationToast = (e, message, displayName) => {
            displayToast(message, displayName);
            if (!this.$rootScope.$$phase)
                scope.$apply();
        };
        const displayToast = (message, displayName) => {
            this.toast({
                duration: 3000,
                message: `${displayName} ${this.$translate.instant(message)}`,
                className: 'basic-toast',
                position: "center",
                container: '.toast-container'
            });
        };
        const resetIsolatedScope = () => {
            this.isolatedScope = {
                ongoingInvitations: 0
            };
        };
        this.$rootScope.$on(this.MeetingroomsInviteManager.DISPLAY_INVITATION_TOAST_EVENT, onDisplayInvitationToast.bind(this));
        this.$rootScope.$on(this.MeetingroomsInviteManager.NEW_INVITATION_COUNT_EVENT, onNewInvitationCount.bind(this));
        scope.$on('$destroy', resetIsolatedScope).bind(this);
    }
}
exports.default = MeetingroomsInviteDisplayer;
MeetingroomsInviteDisplayer.$inject = ["$rootScope", "MeetingroomsInviteManager", "toast", "$translate"];
